var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"block":"","color":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.startDownload.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('Antwort runterladen'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }